import { render, staticRenderFns } from "./AlertList.vue?vue&type=template&id=4fc8d664&scoped=true&"
import script from "./AlertList.vue?vue&type=script&lang=ts&"
export * from "./AlertList.vue?vue&type=script&lang=ts&"
import style0 from "./AlertList.vue?vue&type=style&index=0&id=4fc8d664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8d664",
  null
  
)

export default component.exports